/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import HomeLayout from "../../Components/ehealth/Layout";
import { updateSearchParameters, updateSearchResults } from "../../Redux/SearchEngine/actions";
import Api from "../../Server/Api";
import SideBarSearchFilter from "./v2components/SearchFilter";
import SearchHeader from "./v2components/SearchHeader";
import SearchPagination from "./v2components/SearchPagination";
import SearchResults from "./v2components/SearchResults";


const api = new Api();


export const SearchEngineV2 = (props) => {
  const search = props?.search;
	const DATA = search?.results || [];
	const searching = props?.search?.searching;
  const [viewmode, setViewmode] = React.useState("Grid");
  const [expandMobileSearch, setExpandMobileSearch] = React.useState(false);
  return (
    <HomeLayout hideSearch={true}>
        <div  className="search-engine-v2">
            <SearchHeader expandMobileSearch={expandMobileSearch} setExpandMobileSearch={setExpandMobileSearch} count={search.count} changeView={setViewmode} />
            <div className="columns">
                <div className="column is-3">
                    <SideBarSearchFilter 
                    searching={searching} 
                    expandMobileSearch={expandMobileSearch} 
                    setExpandMobileSearch={setExpandMobileSearch} />
                </div>
                <div className="column is-9">
                    <SearchResults viewmode={viewmode} results={DATA} loading={searching} />
                   <SearchPagination />
                </div>
            </div>
        </div>
    </HomeLayout>
  )
}



const mapStateToProps = ({ search, searchParameters, categories }) => {
	return {
		search,
		searchParameters,
		categories: categories.allcategories.sort(function compare( a, b ) {
            if ( a.title < b.title ){
              return -1;
            }
            if ( a.title > b.title ){
              return 1;
            }
            return 0;
          }),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSearchResults: (e) => dispatch(updateSearchResults(e)),
		updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchEngineV2);
